module.exports = __webpack_public_path__ + "c97a52b405fd73a497669ef17b7edd8d.jpg";